import React, { Component } from 'react'
import PropTypes from 'prop-types'
import times from 'lodash/times'
import Swipeable from 'shared/hocs/Swipeable'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

export default class Carousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeIndex: 0 }
    this.slides = this.prepareItemsPerSlide()
  }

  componentDidMount() {
    this.startInterval()
  }

  componentDidUpdate() {
    this.slides = this.prepareItemsPerSlide()
  }

  componentWillUnmount() {
   clearInterval(this.state.intervalId);
  }

  startInterval = () => {
    if (!this.props.isAutoPlay) {
      return
    }
    const intervalId = setInterval(this.loopSlides.bind(this), this.props.autoPlayInterval);
    this.setState({intervalId: intervalId})
  }

  resetInterval = () => {
    if (!this.props.isAutoPlay) {
      return
    }

    clearInterval(this.state.intervalId);
    this.startInterval()
  }

  loopSlides = () => {
    let index = this.state.activeIndex
    const slidesLength = this.slides.length - 1

    if (index === slidesLength) {
      index = 0
    }
    else {
      ++index
    }
    this.setState({ activeIndex: index })
  }

  prepareItemsPerSlide = () => {
    //define number of items per carusel presentation (slide)
    const slides = []
    const numberOfItems = this.props.children.length
    const numberOfItemsPerSlide = this.props.numberOfItemsPerSlide
    let index = 0
    let numberOfItemsLeft = numberOfItems
    let currNumberOfItemsPerSlide = numberOfItemsPerSlide
      while (index < numberOfItems) {
        //calculate number of items for current slide, the number can change in case the number of items left is smaller than number of items per slide
        currNumberOfItemsPerSlide = (numberOfItemsLeft >= numberOfItemsPerSlide) ? numberOfItemsPerSlide : numberOfItemsLeft
        slides.push(
          <div className="carousel-items" key={index}>
            {times(currNumberOfItemsPerSlide, k => 
              this.props.children[index + k]
            )}
          </div>
          ) 
        numberOfItemsLeft-=numberOfItemsPerSlide
        index+=currNumberOfItemsPerSlide
      }
    return slides
  }

  goToPrevSlide = (e) => {
    this.resetInterval()

    let index = this.state.activeIndex
    const isEndOfSlide = (index < 1)
   
    if (isEndOfSlide && !this.props.isLooped) {
      return
    }

    index = isEndOfSlide && this.props.isLooped ? this.slides.length - 1 : --index
    this.setState({ activeIndex: index })
  }

  goToNextSlide = (e) => {
    this.resetInterval()

    let index = this.state.activeIndex
    const slidesLength = this.slides.length - 1
    const isEndOfSlide = (index === slidesLength)

    if (isEndOfSlide && !this.props.isLooped) {
      return
    }

    index = isEndOfSlide && this.props.isLooped ? 0 : ++index
    this.setState({ activeIndex: index })
  }

  goToSlide = (index) => {
    this.setState({ activeIndex: index })
  }

  renderDefaultIndicators = () => {
    const indicatorStyle = this.props.themeColorHex ? {backgroundColor: this.props.themeColorHex} : {}
    return (
      this.slides.map((slide, index) =>
        <span
          key={index}
          className={
            index == this.state.activeIndex
              ? `carousel-indicator active ${ACCESSIBILITY_CLASSES.main}`
              : `carousel-indicator ${ACCESSIBILITY_CLASSES.main}`
          }
          style={
            index == this.state.activeIndex
              ? indicatorStyle
              : {}
          }
          onClick={e => this.goToSlide(index)}
          onKeyDown={triggerClickOnEnter}
          tabIndex={TAB_INDEXES.CarouselIndicator}
          role="button" />
      )
    )
  }

  render() {
    return(
      <div className="carousel">
        
        <div className="carousel-box">
          <span
            className={`carousel-arrow left ${ACCESSIBILITY_CLASSES.main}`}
            onClick={this.goToPrevSlide}
            onKeyDown={triggerClickOnEnter}
            tabIndex={TAB_INDEXES.CarouselArrow}
            role="button" />
        
          <Swipeable 
            className="swipeable"
            onSwipedLeft={this.goToNextSlide}
            onSwipedRight={this.goToPrevSlide}
            >
            <div  className="carousel-content">
              {this.slides[this.state.activeIndex]}
            </div>
          </Swipeable>
          <span
            className={`carousel-arrow right ${ACCESSIBILITY_CLASSES.main}`}
            onClick={this.goToNextSlide}
            onKeyDown={triggerClickOnEnter}
            tabIndex={TAB_INDEXES.CarouselArrow}
            role="button" />
        </div>
        <div className="carousel-indicators">
          {
            this.props.renderIndicators ?
              this.props.renderIndicators(this.state.activeIndex) :
                this.renderDefaultIndicators()
          }
        </div>
      </div>
    )
  }
}

Carousel.propTypes = {
  themeColorHex: PropTypes.string,
  autoPlayInterval: PropTypes.number,
  isAutoPlay: PropTypes.bool,
  isLooped: PropTypes.bool,
  numberOfItemsPerSlide: PropTypes.number
}

Carousel.defaultProps = {
  autoPlayInterval: 5000,
  isAutoPlay: false,
  isLooped: false,
  numberOfItemsPerSlide: 1
}
